import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/questions/binary`;

export const binaryQuestionsRoutesObj = {
  create: `${baseRoute}/create/:courseId/:examId/`,
  edit: `${baseRoute}/edit/:courseId/:examId/:questionId`,
  view: `${baseRoute}/view/:courseId/:examId/:questionId`,
} as const;

export type IBinaryQuestionsRouteParams = IExtractRouteParamMap<
  typeof binaryQuestionsRoutesObj
>;

export const binaryQuestionPath = createPaths<
  typeof binaryQuestionsRoutesObj,
  IBinaryQuestionsRouteParams
>(binaryQuestionsRoutesObj);
